module.exports = __webpack_public_path__ + "media/images/city_img/m-fe52db51464415a56f18c88904e1083f.jpg";